//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//COMPONENTS AND UTILITIES
import AUselect from '@gov.au/select';
import { AUlabel, AUformGroup } from '@gov.au/form';
import { validateAnswerHasValue } from '../Utilities';

class Select extends Component {
    constructor(props) {
        super(props);

        let answer = {
            value: '',
            key: ''
        };
        let errorMessage = ''

        //TODO : handle repeated questions
        if (props.existingAnswer) {
            answer = props.existingAnswer

        } else {
            if (props.initialValue && this.props.options) {
                const initialValueObject = this.props.options.find(item => item.casa_code === props.initialValue)

                answer = {
                    value: initialValueObject?.casa_name,
                    key: initialValueObject?.casa_code,
                    enccode: initialValueObject?.enccode,
                    refdatatype: initialValueObject?.casa_type
                }
            }
        }
        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage
        }

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        if (props.existingAnswer) {
            if (this.props.onChange) {
                this.props.onChange(questionObject)
            }
        }
        this.props.returnQuestionData(questionObject);
    }

    onChange = (e) => {
        const selectedOption = this.props.options.find(option => option.casa_code === e.target.value);

        const updatedAnswer = {
            ...this.state.answer,
            value: selectedOption?.casa_name ?? "",
            key: selectedOption?.casa_code ?? "",
            enccode: selectedOption?.enccode ?? "",
            refdatatype: selectedOption?.casa_type ?? "",
        }
        const errorMessage = validateAnswerHasValue(this.props.type, updatedAnswer, this.props.mandatory);
       
        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: updatedAnswer
        }

        this.setState({
            errorMessage: errorMessage,
            answer: questionObject.answer
        })

        if (this.props.onChange) {
            this.props.onChange(questionObject)
        }

        this.props.returnQuestionData(questionObject);
    };

    //? not used ?
    //onChangeSelect = (e) => {
    //    const selectedOption = this.props.options.find(option => option.casa_code === e.target.value)
    //    this.setState({
    //        answer: {
    //            ...this.state.answer,
    //            value: selectedOption.casa_name,
    //            key: selectedOption.casa_code,
    //            code: selectedOption.enccode,
    //            refdatatype: selectedOption.refdatatype
    //        }
    //    })
    //}

    getOptions = () => {
        let selectOptions = [{ value: "", text: this.props.defaultText, enccode: "" }]

        if (!this.props.options) {
            return null
        }
        
        const referenceData = this.props.options.map(item => {
            return {
                value: item.casa_code,
                text: item.casa_name,
                enccode: item.enccode,
                refdatatype: item.casa_type
            }
        })
        
        return selectOptions.concat(referenceData)
    }

    renderHintText = () => {
        return {__html: '<span className="au-hint-text">' + this.props.hintText + '</span>' };
    }

    render() {
        return (
            <AUformGroup
                className=""
                status={this.props.getStatus(this.state.errorMessage)}>
                <AUlabel text={this.props.label} htmlFor={this.props.id} />
                {this.props.hintText ? <div dangerouslySetInnerHTML={this.renderHintText()} /> : ""}
                <AUselect
                    id={this.props.id}
                    name={this.props.id}
                    questionid={this.props.id}
                    options={this.getOptions()}
                    aria-describedby={`${this.props.id}-error`}
                    status={this.props.getStatus(this.state.errorMessage)}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    value={this.state.answer.key}
                />
                {this.props.createErrorMessage(this.state.errorMessage)}
            </AUformGroup>
        );
    }
}

Select.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    getStatus: PropTypes.func,
    createErrorMessage: PropTypes.func,
    returnQuestionData: PropTypes.func,
    hintText: PropTypes.string,
    initialValue: PropTypes.string,
    validate: PropTypes.func,
    mandatory: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    existingAnswer: PropTypes.object,
    show: PropTypes.bool.isRequired,
    defaultText: PropTypes.string
};

Select.defaultProps = {
    defaultText: '-- Please select --'
}

export default Select;